import { Box, Container, Divider, Fade, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { COLORS } from '../Constants/styles';
import { CareerForm } from '../Feature/Careers/CareerForm';
import JoinCommunity from '../Feature/Home/JoinCommunity';
import BannerSection from '../Feature/Common/BannerSection';
import { About_IMG } from '../Constants/ImageConstants';

const careersBanner = {
  title: 'Careers',
  description: 'Join Our Team',
  image: About_IMG.aboutEnroll,
};

const Careers = () => {
  return (
    <>
      <BannerSection data={careersBanner} />

      <Box sx={{ py: 6, backgroundColor: COLORS.greyBG, color: COLORS.pureBlack }}>
        <Container maxWidth="md">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center', mb: 2 }}>
              Careers
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.05 }}
          >
            <Typography
              variant="h2"
              sx={{ mt: 5, mb: 2, textAlign: 'center', color: COLORS.pureBlack }}
            >
              Join Us in Building the Future of Grassroots Sports
            </Typography>
          </motion.div>

          <Fade in timeout={1000}>
            <Box sx={{ py: 6, backgroundColor: COLORS.greyBG, display: 'flex', justifyContent: 'center' }}>
              <Container maxWidth="md" sx={{ textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mb: 2, color: COLORS.accentBlackTransparent }}>
                  At Grassroots Sports Education & Services, we're on a mission to transform lives through
                  sport, fitness, and education. We believe in creating opportunities, nurturing talent,
                  and fostering a culture of passion and purpose. If you're driven to make a difference
                  and love the power of sport   we want you on our team.
                </Typography>
              </Container>
            </Box>
          </Fade>

          <CareerForm />
        </Container>
        <Divider sx={{ my: 4 }} />
      </Box>

      <JoinCommunity />
    </>
  );
};

export default Careers;
